import { AnalyticsReporterConfiguration } from './AnalyticsReporterConfiguration';

export enum NPAWLogLevel {
  /** No console outputs */
  SILENT = 6,
  /** Console will show errors */
  ERROR = 5,
  /** Console will show warnings */
  WARNING = 4,
  /** Console will show notices (ie: life-cycle logs) */
  NOTICE = 3,
  /** Console will show debug messages (ie: player events) */
  DEBUG = 2,
  /** Console will show verbose messages (ie: Http Requests) */
  VERBOSE = 1,
}

export interface NPAWAnalyticsReporterConfiguration extends AnalyticsReporterConfiguration {
  /**
   * NPAW account code for analytics reporting.
   * This value must be provided by the NPAW team for each environment.
   */
  accountCode: string;

  /**
   * NPAW logger level for controlling verbosity of NPAW analytics logs.
   * Use NPAWLogLevel to set the desired log level for debugging or production.
   */
  loggerLevel: NPAWLogLevel;

  /**
   * Optional flag to use `user.profileId` as the `userId` in NPAW analytics.
   * If set to `true`, `user.profileId` will be reported in the `userId` field;
   * otherwise, `user.id` will be used.
   */
  shouldUseProfileIdAsUserId?: boolean;
}
